import React from 'react';

import { BadgeWrapper, CircleBadgeWrapper, SimpleTextBadgeWrapper } from './style';

const Badge = ({ status, circleStatus, simpleText }) => {

  return (
    <>
      {circleStatus ? <CircleBadgeWrapper status={status}><span className='circle' /> <span>{status}</span></CircleBadgeWrapper>: simpleText ? <SimpleTextBadgeWrapper status={status}>{status}</SimpleTextBadgeWrapper> : <BadgeWrapper status={status}>{status}</BadgeWrapper>
      }
    </>
  )

};

export default Badge;
